import PublicContentModel from 'gen-thrift/public_content_Model_types';
import { URLStringUtils } from 'shared/utils/urlStringUtils';

import { RuntimeException } from 'shared/lib/general/exceptions/RuntimeException';

export const getPublicContentParameters = (
    publicContentUrl : string,
) : { publicContentUrl : PublicContentModel.PublicContentUrl, publicContentUrlParameters : { [k : string] : Array<string> } } => {

    const location = URLStringUtils.getLocation(publicContentUrl);

    if (location) {
        const hostname : string = location.host;
        const path : string = location.pathname;

        const queryString : string | undefined = publicContentUrl.split('?')[1];
        const publicContentUrlParameters : { [k : string] : Array<string> } = queryString ? URLStringUtils.parseQueryString(queryString) : {};

        return {
            publicContentUrl : new PublicContentModel.PublicContentUrl({
                hostname,
                path,
            }),
            publicContentUrlParameters,
        };
    } else {
        throw new RuntimeException('Could not parse content url: ' + publicContentUrl);
    }
};
